import _invoke from "lodash/invoke";
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { isBrowser, commonPropTypes } from '../../utils';
import { PortalBoxContext } from '../Provider/usePortalBox';
import * as customPropTypes from '@fluentui/react-proptypes';
import { useIsomorphicLayoutEffect } from '@fluentui/react-bindings';

/**
 * A PortalInner is a container for Portal's content.
 */
export var PortalInner = /*#__PURE__*/function () {
  var PortalInner = function PortalInner(props) {
    var context = React.useContext(PortalBoxContext);
    var children = props.children,
        mountNode = props.mountNode; // PortalInner should render elements even without a context
    // eslint-disable-next-line

    var target = isBrowser() ? context || document.body : null;
    var container = mountNode || target;
    useIsomorphicLayoutEffect(function () {
      _invoke(props, 'onMount', props);

      return function () {
        return _invoke(props, 'onUnmount', props);
      };
    }, []);
    return container && /*#__PURE__*/ReactDOM.createPortal(children, container);
  };

  PortalInner.propTypes = Object.assign({}, commonPropTypes.createCommon({
    accessibility: false,
    as: false,
    className: false,
    content: false,
    styled: false
  }), {
    mountNode: customPropTypes.domNode,
    onMount: PropTypes.func,
    onUnmount: PropTypes.func
  });
  return PortalInner;
}();
//# sourceMappingURL=PortalInner.js.map
